module.exports = __webpack_public_path__ + "img/couples-003.56e99ed8.jpg";